module.exports = __webpack_public_path__ + "img/13.8d354af6.jpg";